import styled from 'styled-components';

export const Container = styled.div`
  /* background-image: url(${(props) => props.src}); */
  background-color: #f4f3e9;
  background-image:
    linear-gradient(45deg, #e9e8dc 20%, transparent 20%, transparent 75%, #e9e8dc 75%);
  background-size: 100px 100px;

  background-position: center;
  background-size: cover;
  padding: 5rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.h2`
  margin-bottom: 2.25rem;
  color: var(--black-color);
  text-align: center;
  text-transform: uppercase;

  ::after {
    content: '';
    display: block;
    height: 0.3rem;
    background-color: var(--sixth-color);
    border-radius: 0.5rem;
    margin: 0 auto;
    margin-top: 0.3rem;
    width: 6.25rem;
  }
`;
export const ImgGovernance = styled.img`
  /* background: linear-gradient(160deg, #0e2f1f, #000000); */
`;
